$(document).ready(function() {
    const $container = $('.image_reveal_container');
    const $sliderHandle = $('.slider_handle');
    const $imageRight = $('.image_right');

    function setInitialPosition() {
        const containerWidth = $container.width();
        const initialPosition = containerWidth / 2;

        $sliderHandle.css('left', `${initialPosition}px`);
        $imageRight.css('clip', `rect(0, ${initialPosition}px, auto, 0)`);
    }
    setInitialPosition();
  
    $(window).on('resize', function() {
        setInitialPosition();
    });
  
    $sliderHandle.on('mousedown touchstart', function(e) {
        e.preventDefault();
        $(document).on('mousemove touchmove', function(e) {
            const containerOffset = $container.offset().left;
            const containerWidth = $container.width();
            const cursorPosition = e.pageX || e.originalEvent.touches[0].pageX;
            let newLeft = cursorPosition - containerOffset;
            
            newLeft = Math.max(0, Math.min(newLeft, containerWidth));
            $sliderHandle.css('left', `${newLeft}px`);
            $imageRight.css('clip', `rect(0, ${newLeft}px, auto, 0)`);
        });

        $(document).on('mouseup touchend', function() {
            $(document).off('mousemove touchmove');
        });
    });
});